module.exports = __webpack_public_path__ + "static/media/whyus6.7fee6f15.png";